export default __webpack_public_path__ + "static/media/meat-sour-sweet-chiken.50731054.jpg";